import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ValidationMessageElementFields = {
  group: ELEMENT_GROUPS.TEXT,
  label: 'Validation Message',
  icon: 'DocumentTextIcon',
  description:
    'Adds a text block that can be bound to a validation message for this screen',
  properties: [
    'layout',
    'fontFamily',
    'color',
    'font',
    'alignment',
    {
      name: 'padding',
      label: 'Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'margin',
      label: 'Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '0 20 0 20',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Validation Source',
      name: 'validationSource',
      editor: 'dropdown',
      default: 'validation',
      description:
        'Map the validation message to a particular validation or to any message from any validation on this screen for a particular data source field',
      options: [
        {
          label: 'Single Validation',
          value: 'validation'
        },
        {
          label: 'Any Validation On Selected Field',
          value: 'field'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Background Color (Valid)',
      name: 'backgroundColorValid',
      default: '#c6f6d5',
      editor: 'colorpicker',
      description: 'The background color of error message when it is valid',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Background Color (Invalid)',
      name: 'backgroundColorInvalid',
      default: '#fed7d7',
      editor: 'colorpicker',
      description: 'The background color of error message when it is invalid',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Error Text Color',
      name: 'errorColor',
      default: '#e53e3e',
      editor: 'colorpicker',
      description: 'The text color of when there is a validation error',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'No Error Text Color',
      name: 'noErrorColor',
      default: '#48bb78',
      editor: 'colorpicker',
      description: 'The text color of when there is no validation error',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'On Press Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when the text is pressed.',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Validation Source',
      name: 'validationId',
      description:
        'Choose a validation of this screen that this element is based on.',
      editor: 'dropdown',
      function: {
        name: 'getAppScreenValidations',
        params: ['app.id', 'document.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'validationSource',
          operator: '==',
          value: 'validation'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'validationSource',
          operator: '==',
          value: 'field'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the source of the validation message',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'validationSource',
          operator: '==',
          value: 'field'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Border Radius (Top Left)',
      name: 'borderTopLeftRadius',
      editor: 'number',
      description: 'The border radius of the message at the top left corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius (Top Right)',
      name: 'borderTopRightRadius',
      editor: 'number',
      description: 'The border radius of the message at the top right corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius (Bottom Right)',
      name: 'borderBottomRightRadius',
      editor: 'number',
      description:
        'The border radius of the message at the bottom right corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius (Bottom Left)',
      name: 'borderBottomLeftRadius',
      editor: 'number',
      description: 'The border radius of the message at the bottom left corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of the element',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Style',
      name: 'borderStyle',
      editor: 'dropdown',
      description: 'The border style of the buton',
      default: 'solid',
      options: [
        { label: 'Solid', value: 'solid' },
        { label: 'Dotted', value: 'dotted' },
        { label: 'Dashed', value: 'dashed' }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Color (Valid)',
      name: 'borderColorValid',
      editor: 'color',
      description: 'The border color when the validation has passed',
      default: '#48bb78',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Color (In Valid)',
      name: 'borderColorInvalid',
      editor: 'color',
      description: 'The border color when the validation has not passed',
      default: '#f56565',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    }
  ]
};

export default ValidationMessageElementFields;
